import { render, staticRenderFns } from "./addSkiiScoreWZ.vue?vue&type=template&id=cb216e48&scoped=true"
import script from "./addSkiiScoreWZ.vue?vue&type=script&lang=js"
export * from "./addSkiiScoreWZ.vue?vue&type=script&lang=js"
import style0 from "./addSkiiScoreWZ.vue?vue&type=style&index=0&id=cb216e48&prod&lang=scss&scoped=true"
import style1 from "./addSkiiScoreWZ.vue?vue&type=style&index=1&id=cb216e48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb216e48",
  null
  
)

export default component.exports